import React from 'react';
import Udesk from 'Udesk';
import { Redirect } from 'react-router-dom';
import SubRoutes from 'udesk-react/src/components/sub-routes';
import NavBar from 'udesk-react/src/components/nav-bar';
import SmartWordsLibraryComponent from './component';
import { PageHeader, Tooltip, Icon } from 'udesk-ui';
import { getCurrentRouteName } from 'Udesk/system/subApp';
import UdeskLocales from 'UdeskLocales';
// 不引入udesk-ui全局样式后,需要单独引入某个组件样式
// import 'udesk-ui/lib/form/style/index.css';
// import 'udesk-ui/lib/grid/style/index.css';
// import 'udesk-ui/lib/input/style/index.css';

export default class SmartWordsLibraryTemplate extends SmartWordsLibraryComponent {
    render() {
        let { routes, route, location, sdkOptions } = this.props;
        let { locales } = this;
        const company = Udesk.data.init.company;
        let navLists = [
            {
                pathName: getCurrentRouteName('smartWordsLibraryHotWords'),
                text: /* 热词 */ UdeskLocales['current'].pages.semanticIntelligence
                    .smartWordsLibrary.template.hotWords,
                pathParams: {
                    taskId: this.props.match.params.taskId,
                },
            },
            {
                pathName: getCurrentRouteName('smartWordsLibrarySynonymWords'),
                text: locales.components.pages.smartWordsLibrary.navTabNames.synonymWords,
                pathParams: {
                    taskId: this.props.match.params.taskId,
                },
            },
            {
                pathName: getCurrentRouteName('smartWordsLibrarySensitiveWords'),
                text: /* 敏感词 */ locales.pages.semanticIntelligence.smartWordsLibrary.template
                    .sensitiveWords,
                pathParams: {
                    taskId: this.props.match.params.taskId,
                },
            },
            {
                pathName: getCurrentRouteName('smartWordsLibraryProfessionalWords'),
                text: locales.components.pages.smartWordsLibrary.navTabNames.professionalWords,
                pathParams: {
                    taskId: this.props.match.params.taskId,
                },
            },
            {
                pathName: getCurrentRouteName('smartWordsLibraryAttentionWords'),
                text: locales.components.pages.smartWordsLibrary.navTabNames.attentionWords,
                pathParams: {
                    taskId: this.props.match.params.taskId,
                },
            },
            {
                pathName: getCurrentRouteName('smartWordsLibraryIgnoreWords'),
                text: locales.components.pages.smartWordsLibrary.navTabNames.ignoreWords,
                pathParams: {
                    taskId: this.props.match.params.taskId,
                },
            },
            {
                pathName: getCurrentRouteName('smartWordsLibraryWordsWeight'),
                text: locales.components.pages.smartWordsLibrary.navTabNames.wordsWeight,
                pathParams: {
                    taskId: this.props.match.params.taskId,
                },
            },
            {
                pathName: getCurrentRouteName('smartWordsLibraryCorpusData'),
                text: locales.components.pages.smartWordsLibrary.navTabNames.corpusData,
                pathParams: {
                    taskId: this.props.match.params.taskId,
                },
            },
            {
                pathName: getCurrentRouteName('smartWordsLibraryTypoLibrary'),
                text: locales.components.pages.smartWordsLibrary.navTabNames.typoLibrary,
                pathParams: {
                    taskId: this.props.match.params.taskId,
                },
                isHidden: !(company.enabledImInspect || company.enabledWeComInspect),
            },
            {
                pathName: getCurrentRouteName('smartWordsLibraryTranslationTerminology'),
                text: /* 翻译术语 */ UdeskLocales['current'].pages.semanticIntelligence
                    .smartWordsLibrary.template.translationOfTerms,
                pathParams: {
                    taskId: this.props.match.params.taskId,
                },
            },
        ].filter((item) => !item.isHidden);

        if (this.isRedirect(route, location.pathname)) {
            let toPath = Udesk.ui.routing.getRouteFirstBottomedChildRoutePath({
                routeName: route.name,
                pathParams: this.props.match.params,
            });
            return <Redirect to={toPath} sdkOptions={sdkOptions} />;
        } else {
            return (
                // <div className="smart-words-library">
                <div className="udesk-qa-web-page">
                    <PageHeader
                        className="udesk-qa-web-page-header"
                        title={locales.components.pages.smartWordsLibrary.title}
                        subTitle={
                            <Tooltip
                                placement="bottomLeft"
                                overlayStyle={{ maxWidth: 500 }}
                                title={
                                    <div style={{ whiteSpace: 'pre-wrap' }}>
                                        <div>
                                            {/* 热词：用于提高ASR转写正确率 */}
                                            {
                                                UdeskLocales['current'].pages.semanticIntelligence
                                                    .smartWordsLibrary.template
                                                    .hotWordsUsedToImproveASRTranscriptionAccuracy
                                            }
                                        </div>
                                        <div>{locales.components.pages.smartWordsLibrary.tip1}</div>
                                        <div>
                                            {/* 敏感词：敏感词可配置业务关注词，用于舆情发现敏感词词云 */}
                                            {
                                                locales.pages.semanticIntelligence.smartWordsLibrary
                                                    .template
                                                    .sensitiveWordsSensitiveWordsCanBeConfiguredWithBusinessFocusWordsForPublicOpinionToDiscoverSensitiveWordClouds
                                            }
                                        </div>
                                        <div>{locales.components.pages.smartWordsLibrary.tip2}</div>
                                        <div>{locales.components.pages.smartWordsLibrary.tip3}</div>
                                        <div>
                                            {/* 忽略词：对词云分析中不想关注的词进行屏蔽，帮助AI分析热点符合当前业务 */}
                                            {
                                                UdeskLocales['current'].pages.semanticIntelligence
                                                    .smartWordsLibrary.template
                                                    .ignoreWordsBlockWordsThatYouDontWantToPayAttentionToInWordCloudAnalysisToHelpAIThatAnalysisHotspotsAreInLineWithCurrentBusiness
                                            }
                                        </div>
                                        <div>{locales.components.pages.smartWordsLibrary.tip5}</div>
                                        <div>{locales.components.pages.smartWordsLibrary.tip6}</div>
                                        <div>
                                            {/* 错别字词集：用于优化“错别字检测”的效果，例如”退款”误发送为“退宽”，则可以通过此功能设置常见的错别字以及正确的字，注意保存后次日生效。 */}
                                            {
                                                UdeskLocales['current'].pages.semanticIntelligence
                                                    .smartWordsLibrary.template
                                                    .typosWordSetUsedToOptimizeTheEffectOftyposDetectionForExampleIfrefundIsMistakenlySentAsrefundWidthCommonTyposAndCorrectWordsCanBeSetThroughThisFunctionAndItWillTakeEffectTheNextDayAfterSaving
                                            }
                                        </div>
                                        <div>
                                            {/* 翻译术语：用于优化翻译的效果。当行业中的术语，如产品名称、参数名称等，翻译不准确时，可将术语与其正确的翻译添加为翻译术语。 */}
                                            {
                                                UdeskLocales['current'].pages.semanticIntelligence
                                                    .smartWordsLibrary.template
                                                    .translationTerminologyUsedToOptimizeTheEffectOfTranslationWhenATermInTheIndustrySuchAsProductNameParameterNameEtcIsNotTranslatedCorrectlyTheTermAndItsCorrectTranslationCanBeAddedAsATranslationTerm
                                            }
                                        </div>
                                    </div>
                                }
                            >
                                <Icon type="QuestionCircleOutlined" antdIcon={true}></Icon>
                            </Tooltip>
                        }
                        extra={[
                            <NavBar
                                key={'udesk-qa-web-page-header'}
                                navLists={navLists}
                                classNames="smart-words-library-page-header-right"
                                navItemClassNames="smart-words-library-page-header-nav-item"
                                activeClassNames="smart-words-library-page-header-nav-item-active"
                            />,
                        ]}
                    />
                    <div className="udesk-qa-web-page-body">
                        <div className="udesk-qa-web-page-body-root smart-words-library-page-content">
                            <For each="route" index="i" of={routes}>
                                <SubRoutes key={i} route={route} />
                            </For>
                        </div>
                    </div>
                </div>
            );
        }
    }
}
